<template>
  <v-expansion-panel style="border-radius: 6px">
    <v-expansion-panel-header
      style="font-weight: 600; color: #746b6b; font-size: 12x"
    >
      {{ $t("events.event-config.hidden-pre-sale") }}
    </v-expansion-panel-header>
    <v-expansion-panel-content class="py-6">
      <v-row no-gutters>
        <v-col cols="12" class="mb-4">
          <v-checkbox
            :label="$t('events.event-config.enable-hidden-pre-sale')"
            v-model="$produtos_gerenciar.cadastro.dados_cadastrais.pre_venda"
            class="mt-0 pt-0"
          >
          </v-checkbox>
        </v-col>
        <v-col cols="12">
          <date-time-picker
            :label="$t('events.event-config.event-exibition-date')"
            :edit="$produtos_gerenciar.cadastro.dados_cadastrais.dthr_pre_venda"
            :disabled="disabledDateTimePicker"
            @formatted-date="handleExibitionDateTime"
          ></date-time-picker>
        </v-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import DateTimePicker from "@/components/forms/DateTimePicker.vue";
export default {
  name: "PreSale",
  components: {
    DateTimePicker,
  },
  data: () => ({}),
  computed: {
    disabledDateTimePicker() {
      return !this.$produtos_gerenciar.cadastro.dados_cadastrais.pre_venda
        ? true
        : false;
    },
  },
  methods: {
    handleExibitionDateTime(formatteddatetime) {
      this.$produtos_gerenciar.cadastro.dados_cadastrais.dthr_pre_venda =
        formatteddatetime;
    },
  },
};
</script>

<style scoped></style>
